import ReactPlayer from 'react-player'

interface VideoPreviewProps {
  src: string | undefined
}

const VideoPreview = ({ src }: VideoPreviewProps) => {
  return (
    <ReactPlayer
      url={src}
      controls={true}
      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
      width="100%"
      height="100%"
    />
  )
}

export default VideoPreview
